<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ 'sidebar.catalogDiscount' | translate }}
                </h2>
                <button type="button" class="btn custombutton" (click)="checkRow()">
                    {{ 'buttons.newDiscount' | translate }}
                </button>
            </div>
        </div>
        @if (this.discountReponse.GeneralDiscountCatalogDto && this.discountReponse.GeneralDiscountCatalogDto.length >
        0) {
        <div>
            <fieldset role="radiogroup">
                <table class="table text-center mt-2" role="grid"
                    [attr.aria-label]="'sidebar.catalogDiscount' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ "seleccionarFila" | translate }}</span>
                            </th>
                            <th scope="col">{{ 'discount.codeDiscount' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col">{{ 'catalog.type' | translate }}</th>
                            <th scope="col">{{ 'academicTaxes.order' | translate }}</th>
                            <th scope="col">{{ 'typesVat.percentage' | translate }}</th>
                            <th scope="col">{{ 'discount.amount' | translate }}</th>
                            <th scope="col">{{ 'discount.documentacion' | translate }}</th>
                            <th scope="col">{{ 'discount.externa' | translate }}</th>
                            <th scope="col">{{ 'tariffUsers.checkActive' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let discount of this.discountReponse.GeneralDiscountCatalogDto; let i = index"
                            [ngClass]="{'resaltado': selectedRowId === discount.idGeneralDiscountCatalog}" role="row">
                            <td role="gridcell">
                                <input [ariaLabel]="'flexRadioDefault' + i" type="radio" name="flexRadioDefault"
                                    [id]="'flexRadioDefault' + i"
                                    [checked]="selectedRowId === discount.idGeneralDiscountCatalog"
                                    (click)="checkRow(discount)" />
                                <label [for]="'flexRadioDefault' + i" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'discount.codeDiscount' | translate }} {{ discount.discountCode }},
                                    {{ 'tariffRole.descripcion' | translate }} {{
                                    discount.generalDiscountCatalogTraductionDto?.[0]?.discountDescription || 'N/A' }},
                                    {{ 'catalog.type' | translate }} {{ discount.discountTypology }},
                                    {{ 'academicTaxes.order' | translate }} {{ discount.applicationOrderNumber }},
                                    {{ 'typesVat.percentage' | translate }} {{ discount.discountPercentage }},
                                    {{ 'discount.amount' | translate }} {{ discount.discountFixedAmount }},
                                    {{ 'discount.documentacion' | translate }} {{
                                    discount.discountIndicatorDocumentation
                                    === 'S' ? ('learningResource.S' | translate) : ('learningResource.N' | translate)
                                    }},
                                    {{ 'discount.externa' | translate }} {{ discount.manualValidation === 'TRAM' ?
                                    ('learningResource.tram' | translate) :
                                    discount.manualValidation === 'GESTOR' ? ('learningResource.manager' | translate) :
                                    '----' }},
                                    {{ 'tariffUsers.checkActive' | translate }} {{ discount.active === 'S' ?
                                    ('model.active'
                                    | translate) : ('model.inactive' | translate) }}
                                </label>
                            </td>
                            <td role="gridcell"><span>{{ discount.discountCode }}</span></td>
                            <td role="gridcell">{{
                                discount.generalDiscountCatalogTraductionDto?.[0]?.discountDescription ||
                                '' }}</td>
                            <td role="gridcell"><span>{{ discount.discountTypology }}</span></td>
                            <td role="gridcell"><span>{{ discount.applicationOrderNumber }}</span></td>
                            <td role="gridcell"><span>{{ discount.discountPercentage }}</span></td>
                            <td role="gridcell"><span>{{ discount.discountFixedAmount }}</span></td>
                            <td role="gridcell">{{ discount.discountIndicatorDocumentation === 'S' ?
                                ('learningResource.S' |
                                translate) : ('learningResource.N' |translate) }}</td>
                            <td role="gridcell">{{ discount.manualValidation === 'TRAM' ? ('learningResource.tram' |
                                translate) :
                                discount.manualValidation === 'GESTOR' ? ('learningResource.manager' |translate) :
                                '----' }}
                            </td>
                            <td role="gridcell">
                                @if(discount.active==='S') {
                                <span>{{'model.active' | translate}}</span>
                                }@else{
                                <span>{{'model.inactive' | translate}}</span>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.discountReponse.pageDto">
                <app-paginator [isStart]="this.discountReponse.pageDto.start" [isEnd]="this.discountReponse.pageDto.end"
                    [currentPage]="this.discountReponse.pageDto.currentPage"
                    [totalPages]="this.discountReponse.pageDto.pages"
                    [numberRecord]="this.discountReponse.pageDto.records"
                    [sizePage]="this.discountReponse.pageDto.pageSize">
                </app-paginator>
            </div>

        </div>
        }
        @if (this.selectedRowId || isCreate) {
        <div class="separator mt-5"></div>

        <div>
            <form [formGroup]="discountForm" (ngSubmit)="createOrUpdateDiscount()">
                <div class="mt-5 modelinput-flex">
                    @if(!this.selectedRowId){
                    <h2 class="textformat mb-4 color-text">{{ 'discount.create' |
                        translate }}</h2>
                    }@else {
                    <h2 class="textformat mb-4 color-text">{{ 'discount.editat' |
                        translate }}</h2>
                    }
                </div>

                <div class="row">
                    <!-- Service id -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="discountCode">{{ 'discount.codeDiscount' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="discountCode" name="discountCode"
                            required formControlName="discountCode">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="applicationOrderNumber">{{ 'discount.orderNumber' | translate
                            }}<span>
                                *</span></label>
                        <input type="number" class="form-control color-text" id="applicationOrderNumber"
                            name="applicationOrderNumber" required formControlName="applicationOrderNumber">
                    </div>

                    <div class="mb-3 col-6">
                        <label for="importType" class="form-label">{{'catalog.typeImport' |translate}}</label>
                        <select class="form-select" formControlName="importType" id="importType" name="importType">
                            <option value="I">{{'academicTaxes.import' |translate}}</option>
                            <option value="P">{{'typesVat.percentage' |translate}}</option>
                        </select>
                    </div>
                    @if (discountForm.get('importType')?.value=='I') {
                    <div class="mb-3 col-6">
                        <label for="discountFixedAmount" class="form-label">{{'discount.amount' |translate}}<span>
                                *</span></label>
                        <input type="number" class="form-control" id="discountFixedAmount" name="discountFixedAmount"
                            formControlName="discountFixedAmount" [min]="0" />
                    </div>
                    }

                    @if (discountForm.get('importType')?.value=='P') {
                    <div class="mb-3 col-6">
                        <label for="discountPercentage" class="form-label">{{'typesVat.percentage'| translate}}<span>
                                *</span></label>
                        <input type="number" class="form-control" id="discountPercentage" name="discountPercentage"
                            formControlName="discountPercentage" [min]="0" [max]="100" />
                    </div>
                    }

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="discountTypology">{{ 'catalog.type' | translate }}<span>
                                *</span></label>
                        <select class="form-select" formControlName="discountTypology" id="discountTypology"
                            name="discountTypology">
                            <option value="PERSONA">{{'PERSONA' |translate}}</option>
                            <option value="COD_PROM">{{'COD_PROM' |translate}}</option>
                            <option value="COM_UOC">{{'COM_UOC' |translate}}</option>
                            <option value="ALUMNI">{{'ALUMNI' |translate}}</option>
                            <option value="PROX_MAT">{{'PROX_MAT' |translate}}</option>
                            <option value="OTROS">{{'OTROS' |translate}}</option>

                        </select>
                    </div>
                    <div class="col-6 mb-3">
                        <label for="active">{{ 'model.status' | translate}}<span>
                                *</span></label>
                        <select class="form-select mt-2" formControlName="active" name="active" id="active">
                            <option value="S">{{ 'model.active' | translate }}</option>
                            <option value="N">{{ 'model.inactive' | translate }}</option>
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionCast" class="form-label">{{ 'model.descriptionCast' | translate
                            }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionCast" name="descriptionCast"
                            required formControlName="descriptionCas" [maxlength]="60">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionCat" class="form-label">{{ 'model.descriptionCat' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionCat" name="descriptionCat"
                            required formControlName="descriptionCat" [maxlength]="60">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionEng" class="form-label">{{ 'model.descriptionEng' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="descriptionEng" name="descriptionEng"
                            required formControlName="descriptionEng" [maxlength]="60">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDiscountCat" class="form-label">{{ 'model.infoDiscountCat' | translate
                            }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="infoDiscountCat" name="infoDiscountCat"
                            required formControlName="infoDiscountCat">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDiscountCas" class="form-label">{{ 'model.infoDiscountCas' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="infoDiscountCas" name="infoDiscountCas"
                            required formControlName="infoDiscountCas">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDiscountEng" class="form-label">{{ 'model.infoDiscountEng' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="infoDiscountEng" name="infoDiscountEng"
                            required formControlName="infoDiscountEng">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDocumentationCat" class="form-label">{{ 'model.infoDocumentationCat' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="infoDocumentationCat"
                            name="infoDocumentationCat" formControlName="infoDocumentationCat">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDocumentationCas" class="form-label">{{ 'model.infoDocumentationCas' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="infoDocumentationCas"
                            name="infoDocumentationCas" formControlName="infoDocumentationCas">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="infoDocumentationEng" class="form-label">{{ 'model.infoDocumentationEng' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="infoDocumentationEng"
                            name="infoDocumentationEng" formControlName="infoDocumentationEng">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="sensitiveDataEncodedDescriptionCat" class="form-label">{{
                            'model.sensitiveDataEncodedDescriptionCat' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="sensitiveDataEncodedDescriptionCat"
                            name="sensitiveDataEncodedDescriptionCat"
                            formControlName="sensitiveDataEncodedDescriptionCat">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="sensitiveDataEncodedDescriptionCas" class="form-label">{{
                            'model.sensitiveDataEncodedDescriptionCas' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="sensitiveDataEncodedDescriptionCas"
                            name="sensitiveDataEncodedDescriptionCas"
                            formControlName="sensitiveDataEncodedDescriptionCas">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="sensitiveDataEncodedDescriptionEng" class="form-label">{{
                            'model.sensitiveDataEncodedDescriptionEng' | translate
                            }}</label>
                        <input type="text" class="form-control color-text" id="sensitiveDataEncodedDescriptionEng"
                            name="sensitiveDataEncodedDescriptionEng"
                            formControlName="sensitiveDataEncodedDescriptionEng">
                    </div>

                    <div class="col-md-6 mt-4 ">
                        <input class="form-check-input mx-3" type="checkbox" id="discountIndicatorDocumentation"
                            name="discountIndicatorDocumentation" formControlName="discountIndicatorDocumentation">
                        <label class="form-check-label color-text" for="discountIndicatorDocumentation">
                            {{ 'discount.documentacion' | translate }}
                        </label>
                    </div>

                    <div class="col-md-6 mt-2">
                        <label class="form-check-label color-text" for="manualValidation">
                            {{ 'discount.externa' | translate }}
                        </label>
                        <select class="form-select mt-2" formControlName="manualValidation" name="manualValidation"
                            id="manualValidation">
                            <option [ngValue]="null">----</option>
                            <ng-container *ngFor="let enumValidManual of manualValidationEnum">
                                <option *ngIf="enumValidManual !== null" [ngValue]="enumValidManual">{{ enumValidManual
                                    }}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>
                <button type="button" class="btn cancelbutton mt-3" (click)="selectedRowId = null; ; isCreate = false">
                    {{ 'administrativeTaxes.cancel' | translate }}
                </button>
                @if(!this.selectedRowId){
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'buttons.save' | translate
                    }}</button>
                }@else {
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'buttons.modify' | translate
                    }}</button>
                }

            </form>
        </div>
        }
        <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
            [message]="errorMessage"
            (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
    </main>

</div>